import * as PropTypes from 'prop-types';

export const SavedCreditCards = PropTypes.arrayOf(
  PropTypes.shape({
    id: PropTypes.string.isRequired,
    cardType: PropTypes.string.isRequired,
    last4: PropTypes.string.isRequired,
    expiredAt: PropTypes.string.isRequired
  })
);
